import { render } from "./Detail.vue?vue&type=template&id=1f3ac906&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=1f3ac906&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1f3ac906"

export default script